var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2871_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32H12.3034C4.92134 32 0 27.0787 0 19.6966V0H19.6854C27.0674 0 31.9887 4.92134 31.9887 12.3034V32H32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2246 11.073H19.6853C24.2793 11.073 27.0673 13.8723 27.0673 18.455V27.0674H24.6066C20.0803 27.0674 17.2246 24.1778 17.2246 19.6853V11.073Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92139 4.92139H14.7641V27.0674H12.3034C7.73197 27.0674 4.92139 24.302 4.92139 19.6854V4.92139Z",
    fill: "#004E2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2871_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.236f3204ae7c586723c0b0ec4ba0b6a0.svg";
export { ForwardRef as ReactComponent };